import "../StandartTable/standartTable.css";
import { withNamespaces } from "react-i18next";

import Pagination from "../Pagination/Pagination";
import images from "../../../assets/images";

function WaitingOffersTable({
  t,

  type,

  selectValueId,
  selectValue,
  handleClickValue,

  total,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,

  data,
}) {
  function formatDuration(duration) {
    if (duration <= 0) {
      return t("table_edit_finish");
    }

    const days = Math.floor(duration / (24 * 60 * 60 * 1000));
    duration -= days * 24 * 60 * 60 * 1000;

    const hours = Math.floor(duration / (60 * 60 * 1000));
    duration -= hours * 60 * 60 * 1000;

    const minutes = Math.floor(duration / (60 * 1000));
    duration -= minutes * 60 * 1000;

    const seconds = Math.floor(duration / 1000);

    return `${days} ${t("table_edit_day")}, ${hours} ${t(
      "table_edit_hours"
    )}, ${minutes} ${t("table_edit_minutes")}, ${seconds} ${t(
      "table_edit_second"
    )}`;
  }

  return (
    <div className="standart-table-container">
      <div className="table-box">
        <table>
          <thead>
            <tr>
              <th title={"Foto"}>{t("table_photo")}</th>
              <th title={"Durum"}>{t("table_status")}</th>
              <th title={"Teklif Yapan"}>{t("table_offer_confirm_user")}</th>
              <th title={"Yayınlayan"}>{t("table_issuing")}</th>
              <th title={"Kategori"}>{t("table_category")}</th>
              <th title={"Ürün/Hizmet"}>{t("table_product")}</th>
              <th title={"Tarih"}>{t("table_create_date")}</th>
              <th title={"Kalan Süre"}>{t("table_remaining_time")}</th>
              <th title={"Bütçe"}>{t("table_total_price")}</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row) => {
              const id =
                type === "offer"
                  ? row.offerId
                  : type === "tender"
                  ? row.tenderId
                  : null;
              return (
                <tr
                  key={id}
                  onClick={() => handleClickValue(id, row)}
                  style={{
                    height: "50px",
                  }}
                  className={id === selectValueId ? "table-row-select" : ""}
                >
                  <td
                    className={
                      id === selectValueId ? "table-row-select-text" : ""
                    }
                    title={t("table_photo")}
                  >
                    {row.images && row.images.length > 0 ? (
                      <div className="image-box">
                        <img
                          src={
                            row.images.filter((img) => !img.includes("pdf"))[0]
                          }
                          alt="offer-img"
                        />
                      </div>
                    ) : (
                      <div className="image-box">
                        <img src={images.noImage} alt="offer-img" />
                      </div>
                    )}
                  </td>
                  <td
                    className={
                      id === selectValueId ? "table-row-select-text" : ""
                    }
                    style={{
                      color:
                        row.status === "1"
                          ? "orange"
                          : row.status === "3"
                          ? "red"
                          : row.status === "2"
                          ? "green"
                          : "",
                    }}
                    title={
                      row.status === "3"
                        ? t("table_edit_editing")
                        : row.status === "1"
                        ? t("table_edit_confirm")
                        : null
                    }
                  >
                    {row.status === "3" ? (
                      <i className="fa-solid fa-pen-to-square" />
                    ) : row.status === "1" ? (
                      <i className="fa-solid fa-check" />
                    ) : null}{" "}
                    {row.status === "3"
                      ? t("table_edit_editing")
                      : row.status === "1"
                      ? t("table_edit_confirm")
                      : null}
                  </td>
                  <td
                    className={
                      id === selectValueId ? "table-row-select-text" : ""
                    }
                    title={row.createdUser}
                  >
                    {row.createdUser}{" "}
                  </td>
                  <td
                    className={
                      id === selectValueId ? "table-row-select-text" : ""
                    }
                    title={row.tCompanyName}
                  >
                    {row.tCompanyName}{" "}
                  </td>
                  <td
                    className={
                      id === selectValueId ? "table-row-select-text" : ""
                    }
                    title={row.tenderCategories
                      ?.map((category) => category.categoryName)
                      .join(", ")}
                  >
                    {row.tenderCategories
                      ?.map((category) => category.categoryName)
                      .join(", ")}{" "}
                  </td>
                  <td
                    className={
                      id === selectValueId ? "table-row-select-text" : ""
                    }
                    title={row.tProductName}
                  >
                    {row.tProductName}{" "}
                  </td>
                  <td
                    className={
                      id === selectValueId ? "table-row-select-text" : ""
                    }
                    title={new Date(row.tApproveDate).toLocaleString()}
                  >
                    {new Date(row.tApproveDate).toLocaleString()}{" "}
                  </td>
                  <td
                    className={
                      id === selectValueId ? "table-row-select-text" : ""
                    }
                    title={formatDuration(
                      new Date(row.tExpireDate) - new Date()
                    )}
                  >
                    {formatDuration(new Date(row.tExpireDate) - new Date())}{" "}
                  </td>
                  <td
                    className={
                      id === selectValueId ? "table-row-select-text" : ""
                    }
                    title={
                      row.currency && row.currency !== "string"
                        ? Number(row.totalPrice).toLocaleString(row.currency, {
                            style: "currency",
                            currency: row.currency,
                          })
                        : Number(row.totalPrice).toLocaleString()
                    }
                  >
                    {row.currency && row.currency !== "string"
                      ? Number(row.totalPrice).toLocaleString(row.currency, {
                          style: "currency",
                          currency: row.currency,
                        })
                      : Number(row.totalPrice).toLocaleString()}{" "}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Pagination
        total={total}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
    </div>
  );
}

export default withNamespaces()(WaitingOffersTable);
